<template>
  <div class="d-flex flex-column" id="app" style="min-height: 100vh;" :class="{ gray: $route.path === '/field' }">
    <Menu v-if="$route.path !== '/field' && $route.path !== '/bill'" />

    <keep-alive>
      <router-view class="view"></router-view>
    </keep-alive>

    <div v-if="$route.path !== '/field' && $route.path !== '/bill'" class="d-flex flex-row justify-content-center p-3">
    </div>
  </div>
</template>

<script>
import Vue from 'vue'
import VueRouter from 'vue-router'
import Menu from '@/components/menu'
import Home from '@/components/home'
import App from '@/components/app'
// import StageNew from '@/components/stagenew'
import Stage from '@/components/stage'
import Integration from '@/components/integration'
import FAQ from '@/components/faq'
import Field from '@/components/field'
import Bill from '@/components/bill_table'
import Order from '@/components/bill_order'

import axios from 'axios'
import Bitrix24 from '@/lib/Bitrix24'
import common from '@/lib/common'
import urls from '@/lib/urls'

Vue.use(VueRouter)

const router = new VueRouter({
  mode: 'history',
  base: __dirname,
  routes: [
    { path: '/', name: 'home', component: Home, meta: { requiresAuth: true } },
    { path: '/field', name: 'field', component: Field, meta: { requiresAuth: true } },
    { path: '/stages', name: 'stages', component: Stage, meta: { requiresAuth: true } },
    { path: '/bill', name: 'bill', component: Bill, meta: { requiresAuth: false } },
    { path: '/order', name: 'order', component: Order, meta: { requiresAuth: true } },
    // { path: '/stagenew', name: 'stages new', component: StageNew, meta: { requiresAuth: true }},
    { path: '/app', name: 'app', component: App, meta: { requiresAuth: true } },
    { path: '/integrations', name: 'integration', component: Integration, meta: { requiresAuth: true } },
    { path: '/faq', name: 'FAQ', component: FAQ, meta: { requiresAuth: true } },
    { path: '*', name: 'root', component: Home, meta: { requiresAuth: true } },
  ]
})

router.beforeEach(async (to, from, next) => {
  if (to.matched.some(record => record.meta.requiresAuth)) {
    if (localStorage.token == null) {
      const self = this

      let auth_info = await Bitrix24.getAuthInfo()

      if (auth_info) {
        let domain = auth_info.domain
        let token = auth_info.access_token
        await common.authorization(token, domain).then(response => {
          if (response.status) {
            next({
              path: '/',
              params: { nextUrl: '/' }
            })
          }
        }).catch(error => {
          console.log(error)
        })
      }
    } else {
      next()
    }
  } else {
    // if (localStorage.token != null) {
    //   next({
    //     path: '/',
    //     params: { nextUrl: '/' }
    //   })
    // } else {
    //   next()
    // }
    next()
  }
})

export default {
  name: 'app',
  router,
  components: {
    Menu
  },
  data() {
    return {

    }
  },
  created() {
    let width = 0
    let height = 500

    if (this.$route.name !== 'field') {
      let app = document.querySelector('#app')
      let bx = BX24.getScrollSize()
      if (bx.scrollHeight < 500) {
        height = 500
      } else {
        height = bx.scrollHeight
      }
      Bitrix24.fitWindow(app.offsetWidth, height).then(response => {
        console.log(response)
      })
    }
  },
  methods: {

  },
}
</script>

<style>
.fade-enter-active,
.fade-leave-active {
  transition: opacity .3s;
}

.fade-enter,
.fade-leave-to

/* .fade-leave-active до версии 2.1.8 */
  {
  opacity: 0;
}

.gray {
  background: #f9fafb !important;
}

.container {
  max-width: 100% !important;
}

@media print {

  .nav,
  button,
  .flex-row {
    display: none !important;
  }
}
</style>
